import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import PaymentSummary from './PaymentSummary';
import SettlementDataForm from './SettlementDataForm';
import AccountingNotes from './AccountingNotes';
import BankAccountNumber from './BankAccountNumber';

const SettlementTab = ({ updateOrders, formik }) => {
  const { module } = useSelector(state => state.app);

  return (
    <Box display="flex" flexDirection="column" mt={1}>
      <PaymentSummary />
      <BankAccountNumber />
      <SettlementDataForm updateOrders={updateOrders} formik={formik} />
      <AccountingNotes formik={formik}/>
    </Box>
  );
};


export default SettlementTab;
